import * as Types from 'src/actions/project/index-person-invested/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import IndexResponse from 'src/value-objects/IndexResponse';
import ValidatorService from 'src/services/validation/Validation.service';

export interface IndexPersonInvestedProjectsAttempt extends Action {
  type: Types.INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT;
  payload: number;
}

export interface IndexPersonInvestedProjectsSuccess extends Action {
  type: Types.INDEX_PERSON_INVESTED_PROJECTS_SUCCESS;
  payload: Project[];
}

export interface IndexPersonInvestedProjectsFailure extends Action {
  type: Types.INDEX_PERSON_INVESTED_PROJECTS_FAILURE;
  payload: {};
}

export type IndexPersonInvestedProjectsAction = IndexPersonInvestedProjectsAttempt |
  IndexPersonInvestedProjectsSuccess |
  IndexPersonInvestedProjectsFailure;

export interface IndexPersonInvestedProjectsThunk
  extends ThunkAction<Promise<IndexPersonInvestedProjectsAction>, RootState, string> {
}

export const indexPersonInvestedProjectsAttempt: ActionCreator<IndexPersonInvestedProjectsAttempt> = (
  profileId: number
) => ({
  type: Types.INDEX_PERSON_INVESTED_PROJECTS_ATTEMPT,
  payload: profileId,
});

export const indexPersonInvestedProjectsSuccess: ActionCreator<IndexPersonInvestedProjectsSuccess> = (
  projects: Project[]
) => ({
  type: Types.INDEX_PERSON_INVESTED_PROJECTS_SUCCESS,
  payload: projects
});

export const indexPersonInvestedProjectsFailure: ActionCreator<IndexPersonInvestedProjectsFailure> = (
  error: {}
) => ({
  type: Types.INDEX_PERSON_INVESTED_PROJECTS_FAILURE,
  payload: error
});

export const indexPersonInvestedProjects: ActionCreator<IndexPersonInvestedProjectsThunk> =
  (id: number, personType: string): IndexPersonInvestedProjectsThunk => {
    return (dispatch: Dispatch<RootState>): Promise<IndexPersonInvestedProjectsAction> => {
      dispatch(indexPersonInvestedProjectsAttempt(id));

      return ApiClient.personInvestedProjects.index({personId: id, profileType: personType})
        .then((response: AxiosResponse<IndexResponse<Project>>): IndexPersonInvestedProjectsSuccess => {
          const projects: Project[] = response.data.content;
          return dispatch(indexPersonInvestedProjectsSuccess(projects));
        }).catch((e: { response: { data: { error: {} } } }): IndexPersonInvestedProjectsFailure => {
          const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(indexPersonInvestedProjectsFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/index-person-invested/IndexPersonInvestedProjects.actions.tsx